import { IScan, IScanPersistence } from '../interfaces';

export class ScanMapper {
  public static toDomain(scan: IScanPersistence): IScan {
    return {
      id: scan.id,
      inspectionId: scan.inspection_id,
      declarationId: scan.declaration_id,
      trackCode: scan.track_code?.toString() || '',
      trendyol: scan.trendyol,
      barcode: scan.barcode,
      partnerId: scan.partner_id,
      scannedAt: scan.scanned_at,
      createdAt: scan.created_at,
    };
  }
}
